import React, { useEffect } from "react";
import { notification } from "antd";
import { useAppSelector } from "App/store/hooks";

/**
 * Mounted once at the app root. Any slice can raise a toast by dispatching
 * `showToast`, and `apiThunk` does so automatically for calls flagged
 * successMsg / errorMsg.
 */
const ToastMessage: React.FC = () => {
  const [api, contextHolder] = notification.useNotification();
  const message = useAppSelector((state) => state.toast.message);
  // The nonce changes on every toast, so an identical repeated message still
  // fires rather than being swallowed as an unchanged dependency.
  const nonce = useAppSelector((state) => state.toast.nonce);

  useEffect(() => {
    if (!message?.type) return;
    api.open({
      message: message.head,
      description: message.text,
      type: message.type,
    });
  }, [nonce]); // eslint-disable-line react-hooks/exhaustive-deps

  return <>{contextHolder}</>;
};

export default ToastMessage;
